import React from 'react';
import { useLocation } from 'react-router-dom';
import MapPageSkeleton from './MapPageSkeleton';
import {
  ReservationsTabSkeleton,
  LunchTabSkeleton,
  PlanningTabSkeleton,
  UsersTabSkeleton,
  AssetsTabSkeleton,
  ReportsAssetsTabSkeleton,
  ReportsDeskbookingTabSkeleton,
  ReportsLunchTabSkeleton,
  TalentDirectoryTabSkeleton,
} from './TabSkeletons';
import {
  AdminShellSkeleton,
  AssetControlPageSkeleton,
  MeetingRoomsPageSkeleton,
  MyReservationsPageSkeleton,
  ProfilePageSkeleton,
  ReportsShellSkeleton,
  TalentShellSkeleton,
} from './PageSkeletons';

const ADMIN_TAB_SKELETONS: Record<string, React.FC> = {
  reservaciones: ReservationsTabSkeleton,
  almuerzos: LunchTabSkeleton,
  planificacion: PlanningTabSkeleton,
  usuarios: UsersTabSkeleton,
  activos: AssetsTabSkeleton,
};

const REPORT_TAB_SKELETONS: Record<string, React.FC> = {
  almuerzos: ReportsLunchTabSkeleton,
  deskbooking: ReportsDeskbookingTabSkeleton,
  activos: ReportsAssetsTabSkeleton,
};

/**
 * Suspense fallback for the lazy routes. It renders the skeleton of the page
 * being navigated to, so the chunk download and that page's own loading state
 * look identical and the transition reads as a single step.
 */
const RouteFallback: React.FC = () => {
  const { pathname, search } = useLocation();

  if (pathname === '/') return <MapPageSkeleton />;
  if (pathname.startsWith('/meetingReservation')) return <MeetingRoomsPageSkeleton />;
  if (pathname.startsWith('/myreservations')) return <MyReservationsPageSkeleton />;
  if (pathname.startsWith('/perfil')) return <ProfilePageSkeleton />;
  if (pathname.startsWith('/control-activos')) return <AssetControlPageSkeleton />;

  if (pathname.startsWith('/reportes')) {
    const slug = pathname.split('/')[2]?.toLowerCase() ?? 'almuerzos';
    const TabSkeleton = REPORT_TAB_SKELETONS[slug] ?? ReportsLunchTabSkeleton;
    return (
      <ReportsShellSkeleton>
        <TabSkeleton />
      </ReportsShellSkeleton>
    );
  }

  if (pathname.startsWith('/skills')) {
    return (
      <TalentShellSkeleton>
        <TalentDirectoryTabSkeleton />
      </TalentShellSkeleton>
    );
  }

  if (pathname.startsWith('/admin')) {
    const tab = new URLSearchParams(search).get('tab') ?? 'reservaciones';
    const TabSkeleton = ADMIN_TAB_SKELETONS[tab] ?? ReservationsTabSkeleton;
    return (
      <AdminShellSkeleton>
        <TabSkeleton />
      </AdminShellSkeleton>
    );
  }

  return <MyReservationsPageSkeleton />;
};

export default RouteFallback;
